var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-temoignage';
                    var viewUrl = 'sprite.svg#view-icon-temoignage';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 34',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };